import React, { useEffect } from 'react';
import type { STImage, STMatrix } from '@types';
import { stEnterKrpPlayer } from '../../../sandTable/STKrpPlayer';

interface Props {
  data: STImage | STMatrix;
}
const PLAYER_ID = 'st_krp';

export function LayerMatrix({ data }: Props) {
  useEffect(() => {
    stEnterKrpPlayer.create({
      target: PLAYER_ID,
      data,
      onReady: handleReady,
    });
    return () => {
      stEnterKrpPlayer.remove();
    };
  }, [data]);

  const handleReady = () => {
    data.markers.forEach((marker) => {
      stEnterKrpPlayer.addMarker(marker, { dragable: false });
    });
  };

  return <div className="absolute inset-0 " id={PLAYER_ID} />;
}
